import { usePage, useWebsiteSettings } from 'client/store'
import {
  isWebsitePageType,
  pageSelectors,
} from 'client/store/page/pageSelectors'
import {
  appendGoogleFonts,
  entitiesWithFontOptions,
  GoogleFontProperties,
} from 'common/utils/fontsUtils'
import { useEffect } from 'react'
import {
  getWebsiteStylesAllTypography,
  getWebsiteStylesTypographyHeading,
  getWebsiteStylesTypographyParagraph,
} from 'src/editor/store/website-settings/website-settings-selector'
import { PageEntityInterface } from 'src/shared/types/base-entity-interface'
import { PageGoogleFontsGenerator } from 'src/shared/utils/page-google-fonts-generator'
import { WebsiteGoogleFontsGenerator } from 'src/shared/utils/website-google-fonts-generator'

function usePageFonts() {
  const globalFontProperties = usePage(page =>
    pageSelectors.getGlobalFontProperties(page),
  )

  const entities = usePage(page =>
    pageSelectors.getEntitiesByTypes(page, entitiesWithFontOptions),
  )
  const websiteStyleTypographies =
    useWebsiteSettings(getWebsiteStylesAllTypography) || []
  const isWebsitePage = usePage(isWebsitePageType)
  const websiteHeadingTypography = useWebsiteSettings(
    getWebsiteStylesTypographyHeading,
  )
  const websiteParagraphTypography = useWebsiteSettings(
    getWebsiteStylesTypographyParagraph,
  )
  const pageGenerator = new PageGoogleFontsGenerator()
  const websiteGenerator = new WebsiteGoogleFontsGenerator()

  let googleFontsCss = ''
  if (isWebsitePage) {
    googleFontsCss = websiteGenerator.generateFonts(
      entities as PageEntityInterface[],
      {
        heading: websiteHeadingTypography as GoogleFontProperties,
        paragraph: websiteParagraphTypography as GoogleFontProperties,
      },
      websiteStyleTypographies,
    )
  } else {
    googleFontsCss = pageGenerator.generateFonts(
      entities as PageEntityInterface[],
      globalFontProperties,
    )
  }

  useEffect(() => {
    appendGoogleFonts(googleFontsCss)
  }, [googleFontsCss])
}

export default usePageFonts
